import { Stack } from "@fluentui/react";
import SyntaxHighlighter from "react-syntax-highlighter";

import styles from "./AnalysisPanel.module.css";

import { Thoughts } from "../../api";

interface Props {
    thoughts: Thoughts[];
}

export const ThoughtProcess = ({ thoughts }: Props) => {
    return (
        <ul className={styles.tList}>
            {thoughts.map((t, ind) => {
                const { _reasoning, ...otherProps } = t.props || {};
                return (
                    <li className={styles.tListItem} key={ind}>
                        <div className={styles.tStep}>{t.title}</div>
                        <Stack horizontal tokens={{ childrenGap: 5 }}>
                            {otherProps &&
                                (Object.keys(otherProps) || []).map((k: any) => (
                                    <span className={styles.tProp}>
                                        {k}: {JSON.stringify(otherProps?.[k])}
                                    </span>
                                ))}
                        </Stack>
                        {_reasoning && <div style={{ marginTop: "8px", fontSize: "14px", color: "#333" }}>{_reasoning}</div>}
                        {Array.isArray(t.description) ? (
                            <SyntaxHighlighter language="json" wrapLongLines className={styles.tCodeBlock}>
                                {JSON.stringify(t.description, null, 2)}
                            </SyntaxHighlighter>
                        ) : (
                            <div>{t.description}</div>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};
